import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { mediaUrl, baseURL } from "../axiosInterceptor/axiosInterceptorC";

export const fetchWebsiteById = createAsyncThunk(
  "website/fetchById",
  async (companyName, { rejectWithValue }) => {
    try {
      const login_id = localStorage.getItem("login_id");

      const response = await axios.post(`${baseURL}/website/fetch_websitet_by_id`, {
        company_name: companyName,
        login_id: login_id,
      });

      //console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching website data:", error);
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const websiteSlice = createSlice({
  name: "website",
  initialState: {
    projects2: [],
    testimonials: [],
    GalleryImages: [],
    websiteDetails: {},
    BannerImages: [],
    Properties: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebsiteById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchWebsiteById.fulfilled, (state, action) => {
        const data = action.payload;
        state.isLoading = false;

        // ✅ Testimonials
        state.testimonials = Array.isArray(data.testimonials)
          ? data.testimonials.map((testimonial) => ({
              id: testimonial.id,
              name: testimonial.name_val,
              message: testimonial.message_val,
            }))
          : [];

        // ✅ Gallery Images
        state.GalleryImages = Array.isArray(data.galleryImages)
          ? data.galleryImages.map((image) => ({
              id: image.id,
              url: mediaUrl + image.gallery_images,
              isNew: false,
            }))
          : [];

        // ✅ Website Details
        const websiteDetails = data.websiteDetails?.[0] || {};
        state.websiteDetails = {
          company_name: websiteDetails.company_name || "",
          logo_image: websiteDetails.logo_image || "",
          phone1: websiteDetails.phone_number1 || "",
          phone2: websiteDetails.phone_number2 || "",
          email: websiteDetails.email_id || "",
          address1: websiteDetails.address_line1 || "",
          address2: websiteDetails.address_line2 || "",
          address3: websiteDetails.address_line3 || "",
          facebook: websiteDetails.facebook_val || "",
          instagram: websiteDetails.instagram_val || "",
          youtube: websiteDetails.youtube_val || "",
          linkedin: websiteDetails.linkedin_val || "",
          title: websiteDetails.about_title || "",
          experience: websiteDetails.experience_val || "",
          description: websiteDetails.about_description || "",
        };

        // ✅ Banner Images
        state.BannerImages = Array.isArray(data.bannerImages)
          ? data.bannerImages.map((image) => ({
              id: image.id,
              url: mediaUrl + image.banner_images,
              isNew: false,
            }))
          : [];

        // ✅ Properties & Projects
        state.Properties = Array.isArray(data.property)
          ? data.property.filter((p) => p.checked === true)
          : [];
        state.projects2 = Array.isArray(data.projects)
          ? data.projects.filter((p) => p.checked === true)
          : [];
      })
      .addCase(fetchWebsiteById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default websiteSlice.reducer;
